import { isEnabled } from "utils/featureFlags";

import * as runReducer from "containers/Run/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as optimizerReducer from "containers/Optimizer/reducer";

const UPDATE_FIELD = "optimizerCreator/UPDATE_FIELD";

const initialState = {};

export default function paginationReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    default:
      return state;
  }
}

/* Selectors */
export function getBase(state) {
  return state.optimizerCreator;
}

export function getFirstRunId(state) {
  return getBase(state).firstRunId;
}

export function getSecondRunId(state) {
  return getBase(state).secondRunId;
}

export function getOverallColumn(state) {
  return getBase(state).overallColumn;
}

export function getFirstColumn(state) {
  return getBase(state).firstColumn;
}

export function getSecondColumn(state) {
  return getBase(state).secondColumn;
}

/* Actions */

export function updateFirstRunId(firstRunId) {
  return (dispatch, getState) => {
    dispatch(runReducer.pollJob(firstRunId, true));

    return dispatch({ type: UPDATE_FIELD, data: firstRunId, key: "firstRunId" });
  };
}

export function updateSecondRunId(secondRunId) {
  return (dispatch, getState) => {
    dispatch(runReducer.pollJob(secondRunId, true));

    return dispatch({ type: UPDATE_FIELD, data: secondRunId, key: "secondRunId" });
  };
}

export function updateOverallColumn(overallColumn) {
  return { type: UPDATE_FIELD, data: overallColumn, key: "overallColumn" };
}

export function updateFirstColumn(firstColumn) {
  return { type: UPDATE_FIELD, data: firstColumn, key: "firstColumn" };
}

export function updateSecondColumn(secondColumn) {
  return { type: UPDATE_FIELD, data: secondColumn, key: "secondColumn" };
}

export function getFirstDataset(state) {
  const firstRunId = getFirstRunId(state);

  return setupReducer.getDatasetFromSetup(state, firstRunId);
}

export function getSecondDataset(state) {
  const secondRunId = getSecondRunId(state);

  return setupReducer.getDatasetFromSetup(state, secondRunId);
}

/* Methods */

export function handleCreate() {
  return (dispatch, getState) => {
    dispatch(optimizerReducer.handleCreate());
  };
}
